"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationLookup = exports.UNREACHABLE_SCENARIO = exports.VIEW_ONLY = void 0;
exports.VIEW_ONLY = "View subscription page only";
exports.UNREACHABLE_SCENARIO = "Scenario will never be reached";
exports.configurationLookup = {
    plan1: {
        tier1: {
            settings: "AmplifyAccelerateAll",
            options: "AccelerateAll",
            issueShares: "AmplifyAccelerate2and3and4",
        },
    },
    plan2: {
        tier1: {
            settings: "Amplify2and3and4AccelerateAll",
            options: "AccelerateAll",
            issueShares: "AmplifyAccelerate2and3and4",
        },
        tier2: {
            settings: "Amplify3and4Accelerate2and3and4",
            options: "Accelerate2and3and4",
            issueShares: "AmplifyAccelerate3and4",
        },
        tier3: {
            settings: "Amplify4Accelerate3and4",
            options: "Accelerate3and4",
            issueShares: "Accelerate4Amplify4",
        },
        tier4: {
            settings: "Accelerate4",
            options: "Accelerate4",
            issueShares: exports.UNREACHABLE_SCENARIO, // customers on tier4 will never be asked to upgrade from the issueShares page because tier4 entitles them to unlimited investors
        },
    },
    // customers on plan3 will never be asked to upgrade from the options page because plan3 already entitles them to use options
    plan3: {
        tier1: {
            settings: "Accelerate2and3and4",
            options: exports.UNREACHABLE_SCENARIO,
            issueShares: "Accelerate2and3and4",
        },
        tier2: {
            settings: "Accelerate3and4",
            options: exports.UNREACHABLE_SCENARIO,
            issueShares: "Accelerate3and4",
        },
        tier3: {
            settings: "Accelerate4",
            options: exports.UNREACHABLE_SCENARIO,
            issueShares: "Accelerate4",
        },
        tier4: {
            settings: exports.VIEW_ONLY, // in this scenario, an admin will be able to view their subscription details in the Stripe portal, but won't see a "Update your plan" button
            options: exports.UNREACHABLE_SCENARIO,
            issueShares: exports.UNREACHABLE_SCENARIO,
        },
    },
};
//# sourceMappingURL=configurationLookup.js.map